import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Activity } from "@packages/client";

type RunRuntimeOperationDeploymentRequestProps = {
  projectId: string;
  environmentId: string;
  deploymentId: string;
  operation: string;
  service: string;
};

export const runRuntimeOperationDeploymentRequest = ({
  projectId,
  environmentId,
  deploymentId,
  operation,
  service
}: RunRuntimeOperationDeploymentRequestProps) =>
  apiProxyRequest<{
    code: number;
    status: string;
    _embedded: {
      activities: Activity[];
    };
  }>(
    `/projects/${projectId}/environments/${environmentId}/deployments/${deploymentId}/operations`,
    "POST",
    { operation, service }
  );
